import { render, staticRenderFns } from "./AddModalteacher.vue?vue&type=template&id=14db3c5b&scoped=true"
import script from "./AddModalteacher.vue?vue&type=script&lang=js"
export * from "./AddModalteacher.vue?vue&type=script&lang=js"
import style0 from "./AddModalteacher.vue?vue&type=style&index=0&id=14db3c5b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14db3c5b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14db3c5b')) {
      api.createRecord('14db3c5b', component.options)
    } else {
      api.reload('14db3c5b', component.options)
    }
    module.hot.accept("./AddModalteacher.vue?vue&type=template&id=14db3c5b&scoped=true", function () {
      api.rerender('14db3c5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/AddModalteacher.vue"
export default component.exports